import { render, staticRenderFns } from "./EditPlayerForm.vue?vue&type=template&id=29d88350&"
import script from "./EditPlayerForm.vue?vue&type=script&lang=js&"
export * from "./EditPlayerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports